var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"note system-note timeline-entry being-posted fade-in-half"},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-content"},[_c('em',[_vm._v(_vm._s(_vm.note.body))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7a1da2","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/notes/placeholder_system_note.vue
// module id = null
// module chunks = 